module.exports = __webpack_public_path__ + "img/atletasrefugiados.5e242591.jpg";